import { render, staticRenderFns } from "./OtherReceipt.vue?vue&type=template&id=18ad1849&scoped=true"
import script from "./OtherReceipt.vue?vue&type=script&lang=js"
export * from "./OtherReceipt.vue?vue&type=script&lang=js"
import style0 from "./OtherReceipt.vue?vue&type=style&index=0&id=18ad1849&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ad1849",
  null
  
)

export default component.exports